import Dexie, { type Table } from 'dexie';

import type { CvData, PhotoBlob } from '@/types/cv';

export interface AppSettingRecord {
  key: string;
  value: unknown;
}

export class CvDatabase extends Dexie {
  cvs!: Table<CvData, string>;
  photos!: Table<PhotoBlob, string>;
  settings!: Table<AppSettingRecord, string>;

  constructor(name = 'CVGeneratorDB') {
    super(name);
    this.version(1).stores({
      cvs: 'id, metadata.updatedAt',
      photos: 'id',
      settings: 'key',
    });
  }
}

let dbInstance: CvDatabase | null = null;

export function getDb(): CvDatabase {
  if (!dbInstance) {
    dbInstance = new CvDatabase();
  }
  return dbInstance;
}

export function resetDbForTests(): CvDatabase {
  if (dbInstance) {
    dbInstance.close();
  }
  dbInstance = new CvDatabase('CVGeneratorDB-Test-' + Math.random().toString(36).slice(2));
  return dbInstance;
}
